import { HORIZONTAL_SCROLL_EVENT, HORIZONTAL_SCROLL_ITEM_TRACKING_LABEL_ATTRIBUTE, LOAD_EVENT_TYPE, PROGRESS_EVENT_TYPE, } from '../constants';
export const eventFactory = ({ target, hasScrolled, direction, total, }) => {
    var _a;
    const index = target.dataset.index || '';
    const defaultLabel = target.dataset.label || '';
    const element = target.querySelector(`[${HORIZONTAL_SCROLL_ITEM_TRACKING_LABEL_ATTRIBUTE}]`);
    const label = (_a = element === null || element === void 0 ? void 0 : element.getAttribute(HORIZONTAL_SCROLL_ITEM_TRACKING_LABEL_ATTRIBUTE)) !== null && _a !== void 0 ? _a : defaultLabel;
    const eventType = hasScrolled ? PROGRESS_EVENT_TYPE : LOAD_EVENT_TYPE;
    return new CustomEvent(HORIZONTAL_SCROLL_EVENT, {
        detail: {
            index,
            label,
            type: eventType,
            direction,
            total,
        },
        bubbles: true,
    });
};
